export const SupplierContactsListingMutations = {
  SetSupplierContactsList: 'SupplierContactsListingMutations.SetSupplierContactsList',
  SetSupplierContactsSortOrder: 'SupplierContactsListingMutations.SetSupplierContactsSortOrder',
  SetSupplierContactsPaginationParameters:
    'SupplierContactsListingMutations.SetSupplierContactsPaginationParameters',
  ResetSupplierContactsPaginationOffset:
    'SupplierContactsListingMutations.ResetSupplierContactsPaginationOffset',
  SetSupplierContactsRecordCount:
    'SupplierContactsListingMutations.SetSupplierContactsFilteredRecordCount',
  SetSupplierContactsActiveInactive:
    'SupplierContactsListingMutations.SetSupplierContactsActiveInactive',
  SetSearchParam: 'SupplierContactsListingMutations.SetSearchParam'
};

export const SupplierContactsListingActions = {
  RetrieveSupplierContacts: 'SupplierContactsListingActions.RetrieveSupplierContacts',
  SetSupplierContactsSortOrder: 'SupplierContactsListingActions.SetSupplierContactsSortOrder',
  SelectSupplierContact: 'SupplierContactsListingActions.SelectSupplierContact',
  SetSupplierContactsPaginationParameters:
    'SupplierContactsListingActions.SetSupplierContactsPaginationParameters',
  RetrieveSupplierContactsRecordCount:
    'SupplierContactsListingActions.RetrieveSupplierContactsRecordCount',
  ExportSupplierContactsAsExcel: 'SupplierContactsListingActions.ExportSupplierContactsAsExcel',
  SetSupplierContactsActiveInactive:
    'SupplierContactsListingActions.SetSupplierContactsActiveInactive',
  UpdateSupplierContactsList: 'SupplierContactsListingActions.UpdateSupplierContactsList'
};

export const SupplierContactsListingGetters = {
  SupplierContactsList: 'SupplierContactsListingGetters.SupplierContactsList',
  SortBy: 'SupplierContactsListingGetters.SortBy',
  SortDirection: 'SupplierContactsListingGetters.SortDirection',
  SupplierContactsPerPage: 'SupplierContactsListingGetters.SupplierContactsPerPage',
  SupplierContactsListingOffset: 'SupplierContactsListingGetters.SupplierContactsListingOffset',
  SupplierContactsRecordCount: 'SupplierContactsListingGetters.SupplierContactsRecordCount',
  SupplierContactsActiveInactive: 'SupplierContactsListingGetters.SupplierContactsActiveInactive',
  SupplierContactsSearchParam: 'SupplierContactsListingGetters.SupplierContactsSearchParam'
};
